module.exports = __webpack_public_path__ + "static/media/no.4b57a28e.svg";